import { getUserData } from "../../../global/hooks/getUserRole";
import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export const AccountColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  hideColmn,
  hideBak
) => {
  const logData = getUserData();
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const isSystemUser = [1, 2, 3].includes(logData?.role_value);

  return [
    {
      title: "No",
      dataIndex: "CustomerNo",
      key: "CustomerNo",
      hidden: !isSystemUser,
      sorter: (a, b) => a?.CustomerNo - b?.CustomerNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CustomerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CustomerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Name",
      dataIndex: "CustomerName",
      key: "CustomerName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CustomerName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CustomerName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "CustomerDesc",
      key: "CustomerDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CustomerDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CustomerDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    ...(logData?.role_value === 1
      ? [
          {
            title: "Max Account",
            dataIndex: "MaxAccount",
            key: "MaxAccount",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="MaxAccount"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "MaxAccount",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
          },
        ]
      : []),

    {
      title: "OEM",
      dataIndex: "Oem",
      hidden: hideColmn,
      key: "Oem",
      sorter: (a, b) => () => {},
      // render: (text) => {
      //   return text ? text : "N/A";
      // },
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Oem"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Oem",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "Dealer",
      hidden: [7, 8, 9].includes(logData?.role_value),
      key: "Dealer",
      sorter: (a, b) => () => {},
      // render: (text) => {
      //   return text ? text : "N/A";
      // },
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/customer/edit/${record?.CustomerNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.CustomerNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
